import "./Comp3.css";
import Marquee from "react-fast-marquee";

export default function Comp3() {
  return (
    <div className="comp3">
      <h1>Brands Handpicked Just For You.</h1>
      <Marquee>
        <img src="i1.png" alt="error" className="imgg" />
        <img src="i2.png" alt="error" className="imgg" />
        <img src="i3.png" alt="error" className="imgg" />
        <img src="i4.png" alt="error" className="imgg" />
        <img src="i5.png" alt="error" className="imgg" />
        <img src="i6.png" alt="error" className="imgg" />
        <img src="i7.png" alt="error" className="imgg" />
        <img src="i8.png" alt="error" className="imgg" />
      </Marquee>
    </div>
  );
}
